module.exports = __webpack_public_path__ + "static/img/Materiales_clase.a8fd4046.png";